module.exports = {
  plus: [{
    text: '매우 그렇지 않다',
    score: 1,
    color: 1
  }, {
    text: '그렇지 않다',
    score: 2,
    color: 2
  }, {
    text: '보통이다',
    score: 3,
    color: 3
  }, {
    text: '그렇다',
    score: 4,
    color: 4
  }, {
    text: '매우 그렇다',
    score: 5,
    color: 5
  }],
  minus: [{
    text: '매우 그렇지 않다',
    score: 5,
    color: 1
  }, {
    text: '그렇지 않다',
    score: 4,
    color: 2
  }, {
    text: '보통이다',
    score: 3,
    color: 3
  }, {
    text: '그렇다',
    score: 2,
    color: 4
  }, {
    text: '매우 그렇다',
    score: 1,
    color: 5
  }]
};